<template>
  <OrderPageSection :is-panel="isPanel">
    <OrderInfoTile type="amount" label="订单金额" :value="order.amount" />
    <OrderDescGroup
      v-if="runInWxWork && [0, 10, 70].includes(order.status)"
      :padding-y="16"
      :item-gap="12"
    >
      <OrderDescription label="订单编号" :value="order.orderNo" copiable />
      <OrderDescription
        type="time"
        label="下单时间"
        :value="order.submitTime || order.createdDate"
        time-format="YYYY-MM-DD HH:mm:ss"
      />
    </OrderDescGroup>
    <OrderDescGroup
      v-if="order.status >= 20 && order.status < 70"
      :padding-y="16"
      :item-gap="12"
    >
      <OrderDescription label="订单类型" :value="orderTypeString" />
      <OrderDescription label="订单编号" :value="order.orderNo" copiable />
      <OrderDescription
        type="time"
        label="下单时间"
        :value="order.submitTime || order.createdDate"
        time-format="YYYY-MM-DD HH:mm:ss"
      />
      <OrderDescription label="配送方式" :value="deliveryTypeString" />
      <OrderDescription
        v-if="order.status > 10 && order.payType"
        label="支付方式"
        :value="payTypeString"
      />
      <OrderDescription
        v-if="order.status > 10 && order.payTime"
        type="time"
        label="支付时间"
        :value="order.payTime"
        time-format="YYYY-MM-DD HH:mm:ss"
      />
    </OrderDescGroup>
    <OrderDescGroup
      v-if="
        (runInWeChat && order.status === 10) ||
        (order.status >= 20 && order.status < 70)
      "
      :padding-y="16"
      :item-gap="12"
    >
      <OrderDescription label="销售姓名" :value="order.caName" />
      <OrderDescription label="销售门店" :value="order.storeName" />
    </OrderDescGroup>
    <OrderDescGroup
      v-if="
        runInWxWork &&
        order.status >= 30 &&
        order.status <= 60 &&
        order.posNumber
      "
      :padding-y="16"
      :item-gap="12"
    >
      <OrderDescription
        label="POS单号"
        :value="order.posNumber"
        :editable="canModifyPosNumber"
        copiable
        @edit="$emit('modifyposnumber')"
      />
    </OrderDescGroup>
  </OrderPageSection>
</template>

<script>
import { mapGetters } from "vuex";
import OrderDescGroup from "../widgets/OrderDescGroup.vue";
import OrderDescription from "../widgets/OrderDescription.vue";
import OrderInfoTile from "../widgets/OrderInfoTile.vue";
import OrderPageSection from "../widgets/OrderPageSection.vue";
import { getEnumMap } from "@/api";

export default {
  components: {
    OrderPageSection,
    OrderDescGroup,
    OrderDescription,
    OrderInfoTile,
  },
  props: {
    order: Object,
    isCreator: Boolean,
    refundStatus: Object,
  },
  data() {
    return { inited: false, orderTypeMap: {}, payTypeMap: {} };
  },
  mounted() {
    Promise.all([getEnumMap("OrderTypeEnum"), getEnumMap("PayTypeEnum")]).then(
      ([orderTypeMap, payTypeMap]) => {
        this.orderTypeMap = orderTypeMap;
        this.payTypeMap = payTypeMap;
        this.inited = true;
      }
    );
  },
  computed: {
    ...mapGetters(["runInWxWork", "runInWeChat"]),
    isPanel() {
      if (this.runInWeChat) {
        return this.order.status > 0 && this.order.status < 70;
      }
      return this.order.status > 10 && this.order.status < 70;
    },
    orderTypeString() {
      return this.inited ? this.orderTypeMap[this.order.type] : "";
    },
    deliveryTypeString() {
      return this.order.deliveryMethod === 1
        ? "门店自提"
        : this.order.deliveryMethod === 0
        ? "物流配送"
        : "";
    },
    canModifyPosNumber() {
      return (
        this.isCreator &&
        !this.refundStatus.isRefundingOrDone &&
        this.order.status >= 20 &&
        this.order.status <= 60
      );
    },
    payTypeString() {
      return this.inited ? this.payTypeMap[this.order.payType] : "";
    },
  },
};
</script>
